import { useCallback } from 'react'
import { LocalStorageService } from '@app/services'
import { StorageKeys } from '@app/constants'

export const useTestCallback = () => {
  const onTestCallback = useCallback(async () => {
    const callbackUrl: string = LocalStorageService.getValue(StorageKeys.CallbackUrl)
    const targetUrl = callbackUrl ?? process.env.REACT_APP_TEST_CALLBACK_URL

    if (!targetUrl) return

    window.open(targetUrl, '_self')
  }, [])

  return onTestCallback
}
